// CASPER bridge: a Connect request that arrived while signed out is parked here by CasperConsent.vue and
// resumed after the normal sign-in (password + 2FA, or Raven). Returns true when it navigated.
export const CONSENT_RETURN_KEY = "casper_consent_return";

export function returnToCasperConsent() {
  let back = null;
  try {
    back = sessionStorage.getItem(CONSENT_RETURN_KEY);
    if (back) {
      sessionStorage.removeItem(CONSENT_RETURN_KEY);
    }
  } catch (e) {
    return false;
  }
  if (!back || !back.startsWith("/accounts/casper-consent")) {
    return false;
  }
  window.location.replace(back);
  return true;
}
